// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Typography } from '@mui/material'
import React from 'react'
import { Query } from 'react-apollo'
import Loader from '../../../common/loader/Loader'
import { i18n } from '../../index'
import ChecklistPage from './ChecklistPage'
import css from './checklistPage.css'
import { checklistItemsQuery } from './checklistQueries'
import type { ChecklistItem } from './checklistTypes'

const ChainChecklistItemsPage = () => (
  <div>
    <div className={css.top}>
      <Typography variant='h6'>{i18n.t('admin.checklists.pageTitle')}</Typography>
    </div>
    <Query<{ checklistItems: Array<ChecklistItem> }, Record<string, any>> query={checklistItemsQuery}>
      {({ loading, error, data, refetch }) => (
        <Loader {...{ loading, error }}>
          <ChecklistPage data={data} refetch={refetch} />
        </Loader>
      )}
    </Query>
  </div>
)

export default ChainChecklistItemsPage
